const MAX_QUANTITY = 999

interface AppropriationEntry {
  product?: {
    code?: string | null
  } | null
}

interface AppropriationLine {
  product?: {
    code?: string | null
  } | null
  cartEntries?: AppropriationEntry[] | null
  remainingQuantity?: number | null
  unlimited?: boolean | null
}

interface Appropriation {
  lines?: AppropriationLine[] | null
}

export const getAllowedQuantity = ({
  appropriations,
  productCode,
  cartProductQuantity,
}: {
  appropriations?: Appropriation[] | null
  productCode?: string | null
  cartProductQuantity: number
}): number => {
  const appropriation = appropriations?.find((currentAppropriation) =>
    currentAppropriation?.lines?.find(
      (line) =>
        line.product?.code === productCode || line.cartEntries?.find((entry) => entry.product?.code === productCode)
    )
  )

  const appropriationLine = appropriation?.lines?.find(
    (line) =>
      line.product?.code === productCode || line.cartEntries?.find((entry) => entry.product?.code === productCode)
  )

  if (appropriationLine?.remainingQuantity == null || appropriationLine?.unlimited) {
    return MAX_QUANTITY
  }

  return (appropriationLine?.remainingQuantity ?? 0) + cartProductQuantity
}
